export const CONTINGENT = 'Contingent'
export const PRIMARY = 'Primary'
export const DEFAULT = 'Default'
export const beneficiaryTypes = {
  CONTINGENT,
  PRIMARY,
}

export const contactFormTypes = [CONTINGENT, DEFAULT]

/** Contacts can have repeated names. But the SelectDropdownFormField only accepts unique values.
   *  so we mask the repeated values to be unique. So if there are two Lia Skalkos, one will be
   *  Lia Skalkos, and the other one will be Lia Skalkos (1)
   */

export const maskRepeatedContacts = (adHocContacts, selfId)  => {
  const contactsCounters = {}
  let newAcc
  const mappedContacts = adHocContacts.reduce((acc, contact, index) => {
    newAcc = [...acc, contact]
    const { name } = contact
    if (contact.id === selfId) {
      newAcc = [...acc, {
        ...contact,
        name: `${name} (ME)`
      }]
    } else {
      if (acc.find(e => e.name === name)) {
        const contactCounter = contactsCounters[name]
        newAcc = [...acc, {
          ...contact,
          name: `${name} (${contactCounter})`
        }]
      }
      contactsCounters[name] = contactsCounters[name] ? contactsCounters[name] + 1 : 1
    }
    return newAcc
  }, [])
  return mappedContacts
}

const translatePrimaryAddressFields = (object, typeToReplace, newType) => {
  for (const attr in object) {
    if (typeToReplace.test(attr)) {
      const newTypeEquivalentAttr = attr.replace(typeToReplace, newType)
      object[newTypeEquivalentAttr] = object[attr]
    }
  }

  return { ...object }
}

export const contactToAccountAdapter = (contact) => {
  const mailingRegex = /mailing/
  const adaptedContact = translatePrimaryAddressFields(contact, mailingRegex, 'billing')
  for (const attr in contact) {
    const capitalizedAttr = attr.charAt(0).toUpperCase() + attr.slice(1)
    adaptedContact[`person${capitalizedAttr}`] = contact[attr]
  }
  return { ...adaptedContact }
}

export const accountToContactAdapter = (account) => {
  const billingRegex = /billing/
  const adaptedAccount = translatePrimaryAddressFields(account, billingRegex, 'mailing')
  const personRegex = /person/

  for (const attr in account) {
    if (personRegex.test(attr)) {
      const transformedAttr = attr.replace(personRegex,'')
      const lowercasedAttr = transformedAttr.charAt(0).toLowerCase() + transformedAttr.slice(1)
      adaptedAccount[lowercasedAttr] = account[attr]
    }
  }
  return { ...adaptedAccount }
}

export default {
  contactFormTypes,
}



// WEBPACK FOOTER //
// ./src/utils/contactUtils.js